import React from "react";
import { View, Text } from "@react-pdf/renderer";

interface PDFAssinaturasProps {
  assinaturas: {
    cargoNome?: string;
    pessoaNome?: string;
  }[];
  fontSize?: number;
  marginTop?: number;
}

function PDFAssinaturas({
  assinaturas,
  fontSize,
  marginTop = 32,
}: PDFAssinaturasProps) {
  const _assinaturas = assinaturas.filter(
    (assinatura) => assinatura.cargoNome || assinatura.pessoaNome
  );

  return (
    <View
      minPresenceAhead={30}
      wrap={false}
      style={{
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: _assinaturas.length > 1 ? "space-between" : "center",
        marginTop,
      }}
    >
      {_assinaturas.map((assinatura, index) => (
        <View
          key={index}
          style={{
            textAlign: "center",
            paddingTop: 2,
            borderTopWidth: 1,
            borderTopColor: "black",
            minWidth: "45%",
            maxWidth: "45%",
            flex: 1,
            margin: 10,
            fontWeight: "medium",
          }}
        >
          {assinatura?.pessoaNome ? (
            <Text style={{ fontSize }}>
              {assinatura.pessoaNome.toUpperCase()}
            </Text>
          ) : null}
          {assinatura?.cargoNome ? (
            <Text style={{ fontSize }}>
              {assinatura.cargoNome.toUpperCase()}
            </Text>
          ) : null}
        </View>
      ))}
    </View>
  );
}

export default PDFAssinaturas;
